export default {
  privateSubtitle: 'Deseja enviar convites para responderem esse formulário?',
  publicSubtitle: 'Compartilhe esse link com quem você deseja que responda esse formulários',
  cancel: 'Faço isso depois',
  sendForm: 'Enviar formulário',
  shareLink: 'Link de compartilhamento'
}
